export default "__VITE_ASSET__CF$Gsq7X__"